/**
 * Pure helpers for the custom-role permission checkbox matrix.
 */

export function compareArrays(array1: string[], array2: string[]): { overlapping: string[]; nonOverlapping: string[] } {
    const set1 = new Set(array1);
    const set2 = new Set(array2);

    const overlapping = Array.from(set1).filter((item) => set2.has(item));
    const nonOverlapping1 = Array.from(set1).filter((item) => !set2.has(item));
    const nonOverlapping2 = Array.from(set2).filter((item) => !set1.has(item));

    return { overlapping, nonOverlapping: [...nonOverlapping1, ...nonOverlapping2] };
}

export function buildPermissionMapFromTemplate(options: { [key: string]: string[] }, existing?: { [key: string]: string[] }): { [key: string]: string[] } {
    if (!existing) {
        const empty: { [key: string]: string[] } = {};
        for (const key of Object.keys(options)) {
            empty[key] = [];
        }
        return empty;
    }

    const { overlapping, nonOverlapping } = compareArrays(Object.keys(options), Object.keys(existing));
    const next: { [key: string]: string[] } = { ...options };
    for (const key of overlapping) {
        next[key] = existing[key] ?? [];
    }
    for (const key of nonOverlapping) {
        next[key] = [];
    }
    return next;
}

export function togglePermissionRight(value: { [key: string]: string[] }, key: string, right: string, enabled: boolean): { [key: string]: string[] } {
    const next = { ...value, [key]: [...(value[key] ?? [])] };
    if (enabled) {
        if (!next[key].includes(right)) next[key] = [...next[key], right];
    } else {
        next[key] = next[key].filter((v) => v !== right);
    }
    return next;
}
